module.exports = __webpack_public_path__ + "media/images/v2/Background3-7a6198dec0125f51c3ae39779a297d7c.jpg";